import React from 'react';
import { Button } from 'ui-toolkit';
import { mergeTests } from '../../ui-toolkit/test-utilities/mergeTests';
import { IHasTestData } from '../../ui-toolkit/test-utilities/IHasTestData';

export const SubmitButton: React.FC<IHasTestData> = (props) => {
  return (
    <Button
      {...props}
      as="input"
      intent="primary"
      type="submit"
      form="create-order-form"
      value={'Create Order'}
      data-test-id={mergeTests('button', 'submit', 'create-order')}
    />
  );
};
